import { action } from 'satcheljs';

const loadFavorites = action('LOAD_FAVORITES');
export default loadFavorites;
